import React from "react";
import test1 from "../Testi Images/test1.png";
import test2 from "../Testi Images/test2.png";
import test3 from "../Testi Images/test3.png";
import test4 from "../Testi Images/test4.png";
import test5 from "../Testi Images/test5.png";
const testimonials = [
  {
    name: "Kuldeep Parashar",
    image: test1,
    text: "B.Tech - APE Upstream, 2014 Founder, PensionBox",
  },
  {
    name: "Aayush Bijalwa",
    image: test2,
    text: "M.Des - Industrial and Transportation Design, 2015 Secured a victory in TVS Motor Co.’s Call of Design Season 2 by designing a stylish version of the TVS NTORQ.",
  },
  {
    name: "Bhupendra Verma",
    image: test3,
    text: "BA.LL.B - Energy Law, 2012 Partner, Cyril Amarchand Mangaldas ",
  },
  {
    name: "Nikhil Moghe",
    image: test4,
    text: "MBA - Oil and Natural Gas, 2005 Partner at KPMG, India.",
  },
  {
    name: "Mudit Verma",
    image: test5,
    text: "B.Tech - Aerospace, Aeronautical, and Astronautical Engineering, 2010",
  },
];

const TestimonialCarousel = () => {
  const groupedTestimonials = [];
  for (let i = 0; i < testimonials.length; i += 3) {
    groupedTestimonials.push(testimonials.slice(i, i + 3));
  }
  return (
    <div
      id="testimonialCarousel"
      className="carousel slide"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner">
        {groupedTestimonials.map((group, index) => (
          <div
            className={`carousel-item ${index === 0 ? "active" : ""}`}
            key={index}
          >
            <div className="container">
              <div className="row justify-content-center">
                {group.map((t, i) => (
                  <div
                    key={i}
                    className="col-md-4 d-flex justify-content-center"
                  >
                    <div
                      className="card shadow-sm mb-4 bg-testimonial rounded rounded-5"
                      style={{ width: "25rem", borderRadius: "12px" }}
                    >
                      <img
                        src={t.image}
                        className="card-img-top"
                        alt={t.name}
                        style={{
                          height: "40vh",
                          objectFit: "cover",
                          borderRadius: "12px 12px 0 0",
                        }}
                      />
                      <div className="card-body text-start mt-4 p-4">
                        <h5 className="card-title fw-bold">{t.name}</h5>
                        <hr className="linetwo" />
                        <p className="card-text mb-4">{t.text}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Carousel Controls */}
      <div className="carousel-controls text-center mb-4 mt-4">
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#testimonialCarousel"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#testimonialCarousel"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
        </button>
      </div>
    </div>
  );
};

export default TestimonialCarousel;
